module.exports = __webpack_public_path__ + "static/media/55_000041.204a864b.jpg";